import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import CookiePopup from './components/CookiePopup';
import AgeVerification from './components/AgeVerification';
import BackToTop from './components/BackToTop';
import ScrollToTop from './components/ScrollToTop';
import GamblingWarning from './components/GamblingWarning';
import Home from './pages/Home';
import Comparison from './pages/Comparison';
import About from './pages/About';
import FAQ from './pages/FAQ';
import OfferReview from './pages/OfferReview';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import Terms from './pages/Terms';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-dark-bg">
        <GamblingWarning />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/comparaison" element={<Comparison />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/offres/:id" element={<OfferReview />} />
            <Route path="/politique-confidentialite" element={<PrivacyPolicy />} />
            <Route path="/cookies" element={<CookiePolicy />} />
            <Route path="/conditions" element={<Terms />} />
          </Routes>
        </main>
        <Footer />
        <CookiePopup />
        <AgeVerification />
        <BackToTop />
      </div>
    </Router>
  );
}

export default App;
